import { createSelector } from 'reselect'
import { getCurrentContactId } from 'selectors'

export const getReciprocalRolesState = state => state.reciprocalRoles
export const getContactRelationshipsState = state => state.contactRelationships

const reciprocalRolesByType = (reciprocalRoles, type) => reciprocalRoles.filter(r => r.type === `${type} Role`)
const getContactsState = state => state.contacts

export const getContactReciprocalRoles = createSelector(
  getReciprocalRolesState,
  (allReciprocalRoles) => {
    const { reciprocalRoles } = allReciprocalRoles
    return reciprocalRolesByType(reciprocalRoles, 'Contact')
  }
)

export const getCurrentContactRelationship = createSelector(
  getContactRelationshipsState,
  getCurrentContactId,
  (allContactRelationships, currentContactId) => {
    const { contactRelationships } = allContactRelationships
    return contactRelationships.find(r => r.relatedContact === currentContactId)
  }
)

export const getCurrentContactReciprocalRole = createSelector(
  getCurrentContactRelationship,
  getContactReciprocalRoles,
  (relationship, roles) => {
    if (relationship) {
      return roles.find(r => r.id === relationship.role)
    }
  }
)

export const getContactsWithRelationships = createSelector(
  getContactsState,
  getContactRelationshipsState,
  getContactReciprocalRoles,
  (allContacts, allContactRelationships, roles) => {
    const { contactRelationships } = allContactRelationships
    const { contacts } = allContacts
    const contactsWithRelationship = contacts.map((c) => {
      const relationship = contactRelationships.find(r => r.relatedContact === c.id)
      let relationshipName
      if (relationship) {
        const role = roles.find(r => r.id === relationship.role)
        if (role) {
          relationshipName = role.name
        }
      }
      return { ...c, relationship: relationshipName }
    })
    return contactsWithRelationship
  }
)

export default {
  getContactReciprocalRoles,
  getCurrentContactReciprocalRole,
  getContactsWithRelationships,
  getContactRelationshipsState,
  getCurrentContactRelationship,
}



// WEBPACK FOOTER //
// ./src/selectors/onboarding/contactRelationships.js